<template>
  <div>
    <load-profile></load-profile>
    <!-- Table Container Card -->
    <b-card>
      <validation-observer ref="editForm" #default="{ invalid }">
        <!-- form -->
        <n-form-confirmation
          key="editForm"
          @submit="submit"
          :form="$refs.editForm"
          :disabled="invalid"
        >
          <n-input :fields="fields" v-model="data" :initValue="initData">
            <template #departmentId="item">
              <b-form-group :label-for="item.field.key">
                <validation-provider
                  #default="{ errors }"
                  :vid="item.field.key"
                  :name="$t(item.field.label)"
                  :rules="item.field.rules"
                >
                  <label>
                    {{ $t(item.field.label) }}
                  </label>
                  <n-async-single-select
                    v-model="data[item.field.key]"
                    :query="[
                      {
                        searchby: 'company_id',
                        searchoperator: '=',
                        search: data.companyId,
                      },
                    ]"
                    :ref="item.field.key"
                    :name="item.field.key"
                    :repository="item.field.repository"
                    :selection-key="item.field.selectionKey"
                    :selection-label="item.field.selectionLabel"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  ></n-async-single-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>
            <template #managerId="item">
              <b-form-group :label-for="item.field.key">
                <validation-provider
                  #default="{ errors }"
                  :vid="item.field.key"
                  :name="$t(item.field.label)"
                  :rules="item.field.rules"
                >
                  <label>
                    {{ $t(item.field.label) }}
                    <span
                      class="text-muted"
                      v-if="isOptional(item.field.rules)"
                    >
                      - {{ $t("field.optional") }}
                    </span>
                  </label>
                  <n-async-single-select
                    v-model="data[item.field.key]"
                    :query="[
                      {
                        searchby: 'department_id',
                        searchoperator: '=',
                        search: data.departmentId,
                      },
                      {
                        searchby: 'id',
                        searchoperator: '!=',
                        search: data.id,
                      },
                      {
                        searchby: 'manager_id',
                        searchoperator: '!=',
                        search: data.id,
                      },
                    ]"
                    :ref="item.field.key"
                    :name="item.field.key"
                    :repository="item.field.repository"
                    :selection-key="item.field.selectionKey"
                    :selection-label="item.field.selectionLabel"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  ></n-async-single-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>
          </n-input>
          <b-row>
            <b-col cols="12" class="text-right">
              <n-button-save-option
                ref="btnSubmit"
                @submit="submit"
                @save="save"
                :loading="loading"
                :type="permissionType"
                v-if="$can('update', permissionType)"
              ></n-button-save-option>
              <n-button-loading
                type="button"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-secondary"
                :loading="loading"
                class="mt-1"
                @submit="back"
              >
                {{ $t("button.back") }}
              </n-button-loading>
            </b-col>
          </b-row>
        </n-form-confirmation>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardText,
  BLink,
  BFormRadioGroup,
} from "bootstrap-vue";
import Repository from "@/repositories/RepositoryFactory";
import Ripple from "vue-ripple-directive";
import NButtonLoading from "@/components/NButtonLoading";
import NFormConfirmation from "@/components/NFormConfirmation";
import NInput from "@/components/NInput";
import FormInput from "./formInput";
import NAsyncSingleSelect from "@/components/NAsyncSingleSelect";
import NButtonSaveOption from "@/components/NButtonSaveOption";

const StockAdminRepository = Repository.get("stockAdmin");

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardText,
    BLink,
    BFormRadioGroup,
    NButtonLoading,
    NFormConfirmation,
    NInput,
    NAsyncSingleSelect,
    NButtonSaveOption,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        companyId: null,
        departmentId: null,
        managerId: null,
        positionId: null,
        name: null,
        idCard: null,
        phoneNumber: null,
        username: null,
        isEnable: true,
        roles: [],
      },
      initData: {},
      loading: false,
    };
  },
  watch: {
    "data.companyId"(newValue, oldValue) {
      if (oldValue && newValue != oldValue) {
        this.$refs.departmentId.clear();
      }
    },
    "data.departmentId"(newValue, oldValue) {
      if (oldValue && newValue != oldValue) {
        this.$refs.managerId.clear();
      }
    },
  },
  mounted() {
    this.show();
  },
  methods: {
    isOptional(rules) {
      if (!rules) {
        return true;
      }

      return !rules.includes("required");
    },
    show() {
      StockAdminRepository.show(this.$route.params.id).then((response) => {
        this.initData = {
          ...response.data.data,
        };
      });
    },
    submit(type) {
      this.$refs.editForm.validate().then((success) => {
        if (success) {
          this.$refs.btnSubmit.confirm(type);
        }
      });
    },
    save(type) {
      this.loading = true;
      StockAdminRepository.update(this.$route.params.id, this.data)
        .then((response) => {
          this.$refs.btnSubmit.afterSave(type, response.data.data.id);
        })
        .catch((error) => {
          if (error.response?.status == 422) {
            this.$refs.editForm.setErrors(error.response?.data?.message);
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
    back() {
      this.$router.back();
    },
  },
  setup() {
    const fields = FormInput.map((value) => {
      if (value.key === "password" || value.key === "retypePassword") {
        value.rules = value.rules.replace("required|", "");
        value.rules = value.rules.replace("required", "");
      }

      return value;
    });
    const permissionType = "stock-admin";

    return { fields, permissionType };
  },
};
</script>